import {  Scene, Cameras, ItemManager } from ".";
import { Ground, Grid, Clouds, Sky } from "../base";


/* Environment
 * シーンの各種環境.
 */
export class Environment {

    private _sky: Sky;
    private _ground: Ground;
    private _grid: Grid;
    private _clouds: Clouds;
    private _night: boolean; // temporary for testing, to be replaced with time.

    public get sky(): Sky { return this._sky; }
    public/*use as private*/ set sky(val: Sky) { this._sky = val; }
    public get ground(): Ground { return this._ground; }
    public/*use as private*/ set ground(val: Ground) { this._ground = val; }
    public get grid(): Grid { return this._grid; }
    public/*use as private*/ set grid(val: Grid) { this._grid = val; }
    public get clouds(): Clouds { return this._clouds; }
    public/*use as private*/ set clouds(val: Clouds) { this._clouds = val; }
    public get night(): boolean { return this._night; }
    public set night(value: boolean) {
        this.setNight(value);
    }
    protected setNight(value: boolean) {
        this._night = value;
        if (this._clouds != undefined) this._clouds.night = value;
    }

    //  コンストラクタ
    constructor() {
        this._sky = this.createSky();
        this._ground = this.createGround();
        this._grid = this.createGrid();
        this._clouds = this.createClouds();
        this._night = false;
    }
    protected createSky(): Sky {
        return new Sky;
    }
    protected createGround(): Ground {
        return new Ground;
    }
    protected createGrid(): Grid {
        return new Grid;
    }
    protected createClouds(): Clouds {
        return new Clouds;
    }

    public apply(scene: Scene) {
        if (this.sky != undefined) this.sky.apply(scene);
        if (this.ground != undefined) this.ground.apply(scene);
        if (this.grid != undefined) this.grid.apply(scene);
        if (this.clouds != undefined) this.clouds.apply(scene);
    }

    public reset(scene: Scene) {
        const array = [this.sky, this.ground, this.grid, this.clouds];
        const func = (value) =>{
            if (value!= undefined) {
                value.reset(scene);
                value = undefined;
            }
        }
        array.forEach((value) =>{
            func(value);
        });
    }

    /* update
     * 描画前のアップデート.
     */
    public update(items: ItemManager, cameras: Cameras, timeStamp: number) {
        /* do nothing */
    }
}
